import React from 'react';
import { Alert, Button } from 'antd';

// =============================================================================
// PerformanceCardError — body of a Performance card whose data failed to
// load. Rendered inside the `.campaign-overview__performance` shell in place
// of the KPI row + chart, so the header / range selector stays usable.
// Counterpart of PerformanceCardSkeleton for the failure state: a failed
// fetch must read as a failure, never as a row of zeros.
// =============================================================================

const containerStyle = { padding: 16 };

const PerformanceCardError = ({
  message = "Couldn't load performance data",
  description = 'This data failed to load, so these numbers cannot be shown.',
  onRetry,
}) => (
  <div style={containerStyle}>
    <Alert
      type="error"
      showIcon
      message={message}
      description={description}
      action={
        onRetry ? (
          <Button size="small" danger onClick={onRetry}>
            Retry
          </Button>
        ) : null
      }
    />
  </div>
);

export default PerformanceCardError;
